import {
  IMultiTreatmentPackage,
  ITreatmentConfiguration,
  ITreatmentPackage,
  ITreatmentPackagePriceOverride,
  ServiceCodeType,
} from '@principle-theorem/principle-core/interfaces';
import { MockDocRef } from '@principle-theorem/testing';

export function MockTreatmentPackage(overrides: {
  uid?: string;
  prices: number[];
}): ITreatmentPackage {
  return {
    uid: overrides.uid ?? 'package-1',
    name: 'Package',
    description: '',
    isDefault: false,
    priceOverrides: overrides.prices.map((price) =>
      MockTreatmentPackagePriceOverride('011', price)
    ),
  };
}

export function MockMultiTreatmentPackage(
  prices: number[]
): IMultiTreatmentPackage {
  return {
    uid: 'package-1',
    name: 'Package',
    description: '',
    isDefault: false,
    steps: [
      {
        uid: 'step-1',
        treatments: [
          {
            treatmentRef: MockDocRef<ITreatmentConfiguration>(),
            priceOverrides: prices.map((price) =>
              MockTreatmentPackagePriceOverride('011', price)
            ),
          },
        ],
      },
    ],
  };
}

export function MockTreatmentPackagePriceOverride(
  code: string,
  price: number,
  type = ServiceCodeType.ADA
): ITreatmentPackagePriceOverride {
  return {
    code,
    type,
    price,
  };
}
